import React from 'react';
import { useIntl } from 'react-intl';

import {
  WizardScreen,
  FooterMode
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';

export interface ThreeWayForecastCreatedWizardScreenProps {
  onClose: () => void;
  onView: () => void;
}

export const ThreeWayForecastCreatedWizardScreen = ({ onClose, onView }: ThreeWayForecastCreatedWizardScreenProps) => {
  const intl = useIntl();

  const viewText = intl.formatMessage({
    id: 'predict.create_forecast.go_to_forecast',
    defaultMessage: 'Go to forecast'
  });

  return (
    <WizardScreen footerMode={FooterMode.CREATED} onCancel={onClose} onView={onView} viewText={viewText}>
      <WizardFinished
        text={intl.formatMessage({
          id: 'predict.create_forecast.forecast_created_and_saved_as_a_draft_for_review',
          defaultMessage: 'Forecast created and saved as a draft for review'
        })}
      />
    </WizardScreen>
  );
};
